// LiveKit-Identitäten der Konferenz. Server (Token-Ausgabe, Kick) und Client (Kachel-Zuordnung)
// müssen dasselbe Schema sprechen — deshalb liegt es in shared/.
//
// Stabil pro Teilnehmer, damit ein Reconnect denselben Teilnehmer trifft (LiveKit trennt bei
// doppelter Identität die ältere Verbindung, DUPLICATE_IDENTITY — ein Tab pro Teilnehmer).
// Die Präfixe sind überschneidungsfrei: `host-`, `g-`, `sp-`.

export function hostIdentity(room: string): string {
  return `host-${room.replace(/^studio-/, '')}`;
}
export function guestIdentity(guestId: string): string {
  return `g-${guestId}`;
}
export function speakerIdentity(speakerId: string): string {
  return `sp-${speakerId}`;
}

export function isHostIdentity(identity: string): boolean {
  return identity.startsWith('host-');
}

/**
 * Identität → stabiler Kachel-Schlüssel des UI (`g:<guestId>` / `sp:<speakerId>`), unverändert seit
 * SP3b (CamTile, camLabel). Host und Unbekanntes → null (der Studio-Feed ist keine Kachel).
 */
export function tileKeyOf(identity: string): string | null {
  if (identity.startsWith('g-')) return `g:${identity.slice(2)}`;
  if (identity.startsWith('sp-')) return `sp:${identity.slice(3)}`;
  return null;
}
